import type { ReactElement } from 'react';
import type { ButtonProps as MuiButtonProps } from '@mui/material/Button';

import { StyledButton } from './Button.styled';

/**
 * Shared Button built on MUI Button.
 * @see https://mui.com/material-ui/react-button/
 */
export interface ButtonProps extends MuiButtonProps {
  /** Data test ID for the button. */
  dataTestID?: string;
}

export function Button({ dataTestID = 'button', ...props }: Readonly<ButtonProps>): ReactElement {
  return <StyledButton data-testid={dataTestID} {...props} />;
}

export default Button;
